export const TwentyEight = 'z';